export interface IVehicleGroupItem {
    id: string;
    name: string;
    description: string;
    isDefaultNewIntegrationVehicleGroup : boolean;
}

export class VehicleGroupItem implements IVehicleGroupItem {
    id: string;
    name: string;
    description: string;
    isDefaultNewIntegrationVehicleGroup : boolean;

    constructor();
    constructor(obj: IVehicleGroupItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
        this.description = obj && obj.description || "";
        this.isDefaultNewIntegrationVehicleGroup = obj && obj.isDefaultNewIntegrationVehicleGroup || false;
    }
}